import { DropdownContainer, Menu } from '@lib/components'
import { Badge } from '@octopus-do/octopus-storybook'
import {
  AngleDown,
  Code,
  Table as TableIcon,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { useExportFromSeo } from './useExportFromSeo'

export const ExportFromSeo: React.FC = () => {
  const {
    hasAccess,
    handleExportCsv,
    handleExportXml,
    handleBadgeClick,
    handleMenuClick,
  } = useExportFromSeo()

  const menuItemCls = clsJoin(css.export_menu_item, !hasAccess && css.disabled)

  return (
    <DropdownContainer
      wrapperClassName={css.export_btn_wrapper}
      renderButton={(onSetRef, onClick, isOpen) => (
        <button
          ref={onSetRef}
          className={clsJoin(css.export_btn, isOpen && css.open)}
          onClick={onClick}
        >
          Export
          <AngleDown />
        </button>
      )}
    >
      {(closeDropdown) => (
        <>
          <Menu
            customClassName={clsJoin(!hasAccess && css.menu_disabled)}
            onClick={() => handleMenuClick(handleExportXml, closeDropdown)}
          >
            <div className={menuItemCls}>
              <Code /> XML
              {!hasAccess && (
                <div
                  className={css.export_menu_badge}
                  onClick={(e) => handleBadgeClick(e, closeDropdown)}
                >
                  <Badge type="pro" size="large" />
                </div>
              )}
            </div>
          </Menu>
          <Menu
            customClassName={clsJoin(!hasAccess && css.menu_disabled)}
            onClick={() => handleMenuClick(handleExportCsv, closeDropdown)}
          >
            <div className={menuItemCls}>
              <TableIcon />
              CSV
              {!hasAccess && (
                <div
                  className={css.export_menu_badge}
                  onClick={(e) => handleBadgeClick(e, closeDropdown)}
                >
                  <Badge type="pro" size="large" />
                </div>
              )}
            </div>
          </Menu>
        </>
      )}
    </DropdownContainer>
  )
}
